import { useMutation } from "@tanstack/react-query";
import { sendContactMessage } from "../services/contactService";

export const useSendContactMessage = () => {
  return useMutation({
    mutationFn: sendContactMessage,
  });
};